<template>
  <div class="more">
    <van-sticky>
      <div
        class="moreNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">更多</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="card">
        <div class="top">
          <img src="./../../../assets/decoration/agentLogo.png" />
          <p>{{ identityType == 1 ? "装饰个人代理人" : "装饰企业代理人" }}</p>
          <!-- <p>v1.0</p> -->
        </div>
        <div class="item" @click="toPayFees()">
          <span>{{
            identityType == 1 ? "个人代理人缴费记录" : "企业代理人缴费记录"
          }}</span>
          <img src="./../../../assets/decoration/right.png" />
        </div>
        <div class="item" @click="toContractList()" style="margin: 40px 0 24px">
          <span>{{
            identityType == 1 ? "个人代理人合同列表" : "企业代理人合同列表"
          }}</span>
          <img src="./../../../assets/decoration/right.png" />
        </div>
      </div>
      <div class="card">
        <div class="item" @click="isShow = true">
          <span>切换代理人身份</span>
          <img src="./../../../assets/decoration/right.png" />
        </div>
      </div>
    </div>
    <van-action-sheet v-model="isShow" title="切换身份">
      <div class="sheetContent">
        <div class="card" @click="selectIdentity(1)">
          <div>
            <img src="./../../../assets/decoration/agent.png" alt="" />
            <span>个人代理人</span>
          </div>
          <img
            v-if="identityType == 1"
            src="./../../../assets/decoration/checkedY.png"
            alt=""
          />
          <img
            v-else
            src="./../../../assets/decoration/uncheckedY.png"
            alt=""
          />
        </div>
        <div class="card" @click="selectIdentity(2)">
          <div>
            <img src="./../../../assets/decoration/agentQy.png" alt="" />
            <span>企业代理人</span>
          </div>
          <img
            v-if="identityType == 2"
            src="./../../../assets/decoration/checkedY.png"
            alt=""
          />
          <img
            v-else
            src="./../../../assets/decoration/uncheckedY.png"
            alt=""
          />
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      isShow: false,
      identityType: 1,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.getIdentityType();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取代理人当前身份
    getIdentityType() {
      this.$api.get("decoration/member/city/agent/switch/role").then((res) => {
        this.identityType = res.type;
      });
    },
    toPayFees() {
      this.$router.push({
        path: "/decoration/deputy/payFees",
      });
    },
    toContractList() {
      this.$router.push({
        path: "/decoration/deputy/contractList",
      });
    },
    // 切换身份
    selectIdentity(type) {
      if (type != this.identityType) {
        // 获取是否是代理人
        this.$api
          .get("decoration/member/city/agent/exists", {
            category: "initialization",
          })
          .then((res) => {
            if (type == 1) {
              if (res.jump_individual_agent) {
                // 设置为个人代理人
                this.$api
                  .post("decoration/member/city/agent/switch/role", {
                    type: 1,
                  })
                  .then((res) => {
                    this.identityType = 1;
                    this.isShow = false;
                  });
              } else {
                // 注册个人代理人
                this.$router.push({
                  path: "/decoration/deputy/home",
                  query: {
                    type: 1,
                  },
                });
              }
            } else if (type == 2) {
              if (res.jump_enterprise_agent) {
                // 设置为企业代理人
                this.$api
                  .post("decoration/member/city/agent/switch/role", {
                    type: 2,
                  })
                  .then((res) => {
                    this.identityType = 2;
                    this.isShow = false;
                  });
              } else {
                // 注册企业代理人
                this.$router.push({
                  path: "/decoration/deputy/home",
                  query: {
                    type: 2,
                  },
                });
              }
            }
          });
      }
    },
  },
};
</script>
<style lang="less">
.more {
  height: 100%;
  background: #f5f6ff;
  .moreNav {
    background: #f5f6ff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    .card {
      background: #ffffff;
      border-radius: 12px;
      margin: 16px;
      padding: 24px;
      .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 47px 0 78px;
        img {
          border-radius: 8px;
          width: 64px;
          height: 64px;
          border: 1px solid #f0f1ff;
        }
        p {
          font-size: 13px;
          color: #333333;
          line-height: 18px;
          margin: 12px 0 0;
        }
      }
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 15px;
          font-weight: 400;
          color: #333333;
          line-height: 21px;
        }
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  .sheetContent {
    padding-bottom: 60px;
    .card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 32px 24px;
      background: #f5f6ff;
      border-radius: 12px;
      margin: 12px 16px 0;
      div {
        display: flex;
        align-items: center;
        img {
          height: 48px;
        }
        span {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          margin-left: 12px;
        }
      }
      > img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>